import React from 'react';
import { connect } from 'react-redux';

import DropTarget from './DropTarget';

import gameKit from '../../../../GameKit';

class DropZone extends React.Component {
    onDrop = e => {
        gameKit.levelEditor.blokEditor.spawnPrefab(e.dragData.id, e.x, e.y);
    };

    render() {
        const { children } = this.props;
        return (
            <DropTarget targetKey="game-block" onHit={this.onDrop}>
                {children}
            </DropTarget>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    dragDrop: state.dragDrop
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DropZone);
